import Excerpt from './Excerpt';
export const components = {
  Excerpt
};
flarum.reg.add('fof-synopsis', 'forum/components', null);